import { shallowEqual, useSelector } from 'react-redux'

import ChartsAudienceInsights from '@components/Charts/AudienceInsigths'
import { IApplicationState } from '@store'
import { selectAudienceInsights, selectBrandConnectAudienceInsights } from '@store/audienceInsights'
import { selectIsYouTubeBrandConnect, selectSubmission } from '@store/submissions'
import { getSubmissionFlags } from '@utils/getSubmissionFlags'

interface IProps {
  identityId: number
  isTikTok?: boolean
  submissionId?: number
}

const AnalyticsAudienceInsights: React.FC<IProps> = ({ identityId, submissionId, isTikTok }) => {
  const { isYouTubeBrandConnect, isAudienceInterestEnabled } = useSelector(
    (state: IApplicationState) => {
      let isYouTubeBrandConnect = false

      let isAudienceInterestEnabled = false

      if (submissionId) {
        isYouTubeBrandConnect = selectIsYouTubeBrandConnect(state, submissionId)
        const submission = selectSubmission(state, submissionId)
        const { isPublished } = getSubmissionFlags(submission)
        isAudienceInterestEnabled = isYouTubeBrandConnect && !isPublished
      }

      return { isYouTubeBrandConnect, isAudienceInterestEnabled }
    },
    shallowEqual,
  )

  const { audienceInsights } = useSelector((state: IApplicationState) => {
    if (isYouTubeBrandConnect && submissionId != null) {
      const brandConnectInsights = selectBrandConnectAudienceInsights(state, submissionId)
      if (brandConnectInsights !== null) {
        return { audienceInsights: brandConnectInsights, isYouTubeBrandConnect: true }
      }
    }

    // Use appropriate selector based on submission type
    return { audienceInsights: selectAudienceInsights(state, identityId), isYouTubeBrandConnect }
  }, shallowEqual)

  return (
    <ChartsAudienceInsights
      insights={audienceInsights}
      isTikTok={isTikTok}
      isYtBrandConnect={isYouTubeBrandConnect}
      isAudienceInterestEnabled={isAudienceInterestEnabled}
    />
  )
}

export default AnalyticsAudienceInsights
